/**
 * BoardType
 *
 * @type {Readonly<{INQUIRY_BOARD: string, FREE_BOARD: string, GALLERY_BOARD: string, NOTICE_BOARD: string}>}
 */
export const Board = Object.freeze({
    FREE_BOARD: "free",
    NOTICE_BOARD: "notice",
    GALLERY_BOARD: "gallery",
    INQUIRY_BOARD: "inquiry"
});